const columns = [
  {
    name: 'Size',
    selector: (row) => row.size,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
